import { render } from "./LeadShow.vue?vue&type=template&id=9496558e&scoped=true"
import script from "./LeadShow.vue?vue&type=script&lang=js"
export * from "./LeadShow.vue?vue&type=script&lang=js"

import "./LeadShow.vue?vue&type=style&index=0&id=9496558e&scoped=true&lang=css"

import exportComponent from "/home/travelcrm/travel-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9496558e"]])

export default __exports__